import React, { useRef } from "react";
import { SelectPicker } from "rsuite";
import { Col, FormGroup, Label, Row } from "reactstrap";
import PropTypes from "prop-types";
import { adjustmentTypes, offerTypes } from "./offerTypeConstants";

/**
 * DiscountTypeSelector - First row of OfferType form
 * Contains Adjustment (increase/decrease), Type (percentage/flat) and Calculation Method dropdowns
 * `isCalculationMethodDisabled` locks the Calculation Method picker for CRSs
 * that support a single method (see limitedCalculationType).
 */
function DiscountTypeSelector({
  priceAdjustment,
  onPriceAdjustmentChange,
  discountType,
  onDiscountTypeChange,
  calculationType,
  onCalculationTypeChange,
  calculationOptions,
  isCalculationMethodDisabled = false,
}) {
  const adjustmentContainerRef = useRef(null);
  const offerTypeContainerRef = useRef(null);
  const calculationMethodContainerRef = useRef(null);

  return (
    <Row>
      <Col md={4}>
        <FormGroup>
          <Label for="priceAdjustment">Adjustment</Label>
          <div className="position-relative" ref={adjustmentContainerRef}>
            <SelectPicker
              id="priceAdjustment"
              value={priceAdjustment}
              onChange={(value) => onPriceAdjustmentChange(value)}
              placeholder="Choose adjustment"
              data={adjustmentTypes}
              block
              cleanable={false}
              searchable={false}
              container={() => adjustmentContainerRef.current}
            />
          </div>
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label for="offerType">Type</Label>
          <div className="position-relative" ref={offerTypeContainerRef}>
            <SelectPicker
              id="offerType"
              value={discountType}
              onChange={(value) => onDiscountTypeChange(value)}
              placeholder="Choose a type"
              data={offerTypes}
              block
              cleanable={false}
              searchable={false}
              container={() => offerTypeContainerRef.current}
            />
          </div>
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label for="calculationMethod">Calculation Method</Label>
          <div
            className="position-relative"
            ref={calculationMethodContainerRef}
          >
            <SelectPicker
              id="calculationMethod"
              value={calculationType}
              onChange={onCalculationTypeChange}
              placeholder="Choose method"
              data={calculationOptions}
              cleanable={false}
              searchable={false}
              disabled={isCalculationMethodDisabled}
              block
              container={() => calculationMethodContainerRef.current}
            />
          </div>
        </FormGroup>
      </Col>
    </Row>
  );
}

DiscountTypeSelector.propTypes = {
  priceAdjustment: PropTypes.string,
  onPriceAdjustmentChange: PropTypes.func.isRequired,
  discountType: PropTypes.number,
  onDiscountTypeChange: PropTypes.func.isRequired,
  calculationType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCalculationTypeChange: PropTypes.func.isRequired,
  calculationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  isCalculationMethodDisabled: PropTypes.bool,
};

export default DiscountTypeSelector;
